<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';

const emit = defineEmits(['deleteFromBarcodeScan', 'cancelDelete']);

const isAgreeDel = ref(false);
const isCancelDel = ref(false);
let modalEl = null;
let modalInstance = null;
let hiddenHandler = null;

// 「はい」ボタン押下
const agreeDel = () => {
  isAgreeDel.value = true;
  document.activeElement?.blur();
  modalInstance?.hide();
  emit('deleteFromBarcodeScan');
};

// 「いいえ」ボタン押下
const cancelDelete = () => {
  isCancelDel.value = true;
  modalInstance?.hide();
}

onMounted(() => {
  modalEl = document.getElementById('deleteFromBarcodeScanConfirmModal');
  modalInstance = window.bootstrap?.Modal.getOrCreateInstance(modalEl);

  hiddenHandler = () => {
    if (!isAgreeDel.value) {
      emit('cancelDelete');
    }

    isAgreeDel.value = false;
    isCancelDel.value = false;
  };

  modalEl.addEventListener('hidden.bs.modal', hiddenHandler);
});

onBeforeUnmount(() => {
  if (modalEl && hiddenHandler) {
    modalEl.removeEventListener('hidden.bs.modal', hiddenHandler);
  }
});
</script>

<template>
  <div class="modal com_modal2 fade" id="deleteFromBarcodeScanConfirmModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <img src="/front/assets/common/img/icon_attention1.png" alt="" class="icon_attention1">
          <h3 class="com_fs18 com_strong1 com_center1 com_mgb0">スキャンした商品を削除しますか</h3>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn com_btn1" @click.prevent="agreeDel">はい</button>
          <button type="button" class="btn com_btn2" @click.prevent=cancelDelete>いいえ</button>
        </div>
      </div>
    </div>
  </div>
</template>